import AccountHistory from '../../features/apartment/AccountHistory'

const AccountHistoryPage = () => {
    return (
        <AccountHistory />
    )
}

export default AccountHistoryPage